import { i18n } from '@lingui/core'
import insane from 'insane'

import { Container } from '@twisto/components/atoms/container'
import { Modal, ModalCloser } from '@twisto/components/atoms/modal'
import { Typography } from '@twisto/components/atoms/typography'
import { BigUserIcon } from '@twisto/icons'
import { styleUtils } from '@twisto/styles'

import * as styles from './pep-description-modal.styles'

type Props = {
  opened: boolean
  onClose: () => void
}

export const PepDescriptionModal = ({ opened, onClose }: Props) => (
  <Modal
    autoWidth
    aria-label={
      /*i18n*/
      i18n._(
        'flow.czBasicAccountAgreements.isPoliticallyExposed.modal.notPepDeclaration'
      )
    }
    opened={opened}
    variant="centered"
    onClickOutside={onClose}
  >
    <ModalCloser onClick={onClose} />
    <BigUserIcon color="primary" css={styleUtils.margin.bottom.sm} size="56" />
    <Container size="wide">
      <Typography
        align="start"
        color="textSecondary"
        component="div"
        css={styles.description}
        dangerouslySetInnerHTML={{
          __html: insane(
            /*i18n*/
            i18n._(
              'flow.czBasicAccountAgreements.isPoliticallyExposed.modal.description'
            )
          ),
        }}
        variant="b1"
      />
    </Container>
  </Modal>
)
